import React from 'react';
import { useSelector } from 'react-redux';
import { mainSelectors } from '../../store';
import { Modal } from '../../components';
import { Spinner } from '@swegon-core/ui-components';

export const WaitingModal = (props) => {
    const { show, msg } = useSelector(mainSelectors.getWaitingModalData);

    const finalMessage = (msg) => {
        if (msg?.isSimple && msg?.msg) {
            return msg.msg;
        }
        if (!msg?.isSimple && msg?.msg) {
            const msgArray = msg.msg.split('\n');
            return msgArray.map((item, idx) => <div key={idx}>{item}</div>);
        }
        return 'Please wait ...';
    };

    return (
        <Modal
            fitContent
            show={show}
        >
            <div className="p-4 min-w-min ml-4 mr-4 mt-2">
                <div className="mt-2 mb-2 px-2">{finalMessage(msg)}</div>
                <div className="px-4 sm:flex mb-8 justify-center">
                    <Spinner color="green" />
                </div>
            </div>
        </Modal>
    );
};
